const chat = (state = { messages: [], isNewMessage: false }, action) =>
{
	switch (action.type)
	{
		case 'ADD_NEW_MESSAGE':
		{
			const { text, sender, time, isNewMessage } = action.payload;
			// Ensure that messages is an array before spreading it
			const updatedMessages = Array.isArray(state.messages) ? [...state.messages, { text, sender, time }] : [{ text, sender, time }];

			if (isNewMessage)
			{
				return { isNewMessage, messages: updatedMessages };
			}
			else
			{
				return { ...state, messages: updatedMessages };
			}
		}

		case 'ADD_CHAT_HISTORY':
		{
			const { chatHistory } = action.payload;

			return { ...state, messages: chatHistory };
		}

		case 'SET_READ_MESSAGE':
		{
			return { ...state, isNewMessage: false };
		}

		case 'CLEAR_CHAT':
		{
			return { messages: [], isNewMessage: false };
		}

		default:
			return state;
	}
};

export default chat;
